(function () {
  if (!window.smReserveData) return;

  var marketHandle = window.smReserveData.market || '';
  var variantData = window.smReserveData.variants;
  var badgeKey = marketHandle === 'na' ? 'us' : marketHandle;

  var sid = null;
  var currentTxt = '';
  var origBtnText = null;

  function getSid() {
    var el = document.querySelector('.main-product-section');
    if (el) return el.id.replace('shopify-section-', '');
    var btn = document.querySelector('[id^="ProductSubmitButton-"]');
    return btn ? btn.id.replace('ProductSubmitButton-', '') : null;
  }

  function getVid() {
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    if (m) return parseInt(m[1], 10);
    var inp = document.querySelector('input.product-variant-id') ||
              document.querySelector('input[name="id"][data-productid]');
    return inp ? parseInt(inp.value, 10) : null;
  }

  function getBadgeText(vid) {
    var data = variantData[vid];
    if (!data) return '';
    return data[badgeKey] || '';
  }

  function getBtn() {
    return document.getElementById('ProductSubmitButton-' + sid) ||
           document.querySelector('.product-form__submit[name="add"]');
  }

  function injectBadge() {
    var existing = document.getElementById('sm-reserve-badge-' + sid);
    if (existing) return existing;
    var title = document.querySelector('.product__title');
    if (!title) return null;
    var span = document.createElement('span');
    span.id = 'sm-reserve-badge-' + sid;
    span.style.cssText = [
      'display:none',
      'vertical-align:middle',
      'margin-left:8px',
      'padding:3px 8px',
      'background-color:#DD2C2C',
      'color:#121212',
      'font-family:Helvetica,Arial,sans-serif',
      'font-size:0.65em',
      'font-weight:700',
      'letter-spacing:0.08em',
      'text-transform:uppercase',
      'border-radius:2px',
      'white-space:nowrap',
      'line-height:1.5'
    ].join(';');
    title.appendChild(span);
    return span;
  }

  function captureOrigBtnText() {
    if (origBtnText !== null) return;
    var btn = getBtn();
    if (!btn) return;
    var sp = btn.querySelector(':scope > span') || btn.querySelector('span');
    if (sp) origBtnText = sp.textContent.trim();
  }

  function updateBadge(txt) {
    var isR = txt.length > 0;
    var badge = document.getElementById('sm-reserve-badge-' + sid) || injectBadge();
    if (badge) {
      badge.textContent = txt;
      badge.style.display = isR ? 'inline-flex' : 'none';
    }
    if (!isR) {
      var btn = getBtn();
      if (btn) {
        var sp = btn.querySelector(':scope > span') || btn.querySelector('span');
        if (sp && origBtnText) sp.textContent = origBtnText;
      }
    }
  }

  function enforceButtonText() {
    if (currentTxt.length === 0) return;
    var btn = getBtn();
    if (!btn || btn.classList.contains('loading') || btn.getAttribute('aria-busy') === 'true') return;
    var sp = btn.querySelector(':scope > span') || btn.querySelector('span');
    if (sp && sp.textContent.trim() !== 'RESERVE NOW') sp.textContent = 'RESERVE NOW';
    var stickyBtn = document.querySelector('.sticky-cart-wrapper .product-form__submit');
    if (stickyBtn && !stickyBtn.classList.contains('loading')) {
      var ssp = stickyBtn.querySelector(':scope > span') || stickyBtn.querySelector('span');
      if (ssp && ssp.textContent.trim() !== 'RESERVE NOW') ssp.textContent = 'RESERVE NOW';
    }
  }

  var lastVid = null;

  function tick() {
    if (!sid) sid = getSid();
    if (sid) {
      captureOrigBtnText();
      var vid = getVid();
      if (vid !== lastVid) {
        lastVid = vid;
        currentTxt = getBadgeText(vid);
        updateBadge(currentTxt);
      }
      enforceButtonText();
    }
    requestAnimationFrame(tick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { requestAnimationFrame(tick); });
  } else {
    requestAnimationFrame(tick);
  }
})();